export default "__VITE_ASSET__CjZyc1zk__"